import type { LessonClassOpenGroupMeetingResource } from "api/generated";
import type { ClassroomLessonClassOpenGroupMeeting } from "classroom/types";
import { toDate } from "shared/mappers";

export const lessonClassOpenGroupMeetingFromDto = (
  resource: LessonClassOpenGroupMeetingResource,
): ClassroomLessonClassOpenGroupMeeting => ({
  id: resource.id,
  closedNoModifyAt: toDate(resource.closed_no_modify_at),
  isParticipant: resource.is_participant,
});
